<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    var sUserAgent = navigator.userAgent;
    if (
      sUserAgent.indexOf("Android") > -1 ||
      sUserAgent.indexOf("iPhone") > -1 ||
      sUserAgent.indexOf("iPad") > -1 ||
      sUserAgent.indexOf("iPod") > -1 ||
      sUserAgent.indexOf("Symbian") > -1
    ) {
      window.location.href = "http://www.cnqingxiji.com/public/html/phone/#/pageOne";
    }
  },
};
</script>

<style>
@import url("//at.alicdn.com/t/font_1505816_x1igc06vwl.css");

body {
  margin: 0;
}

/* -webkit-text-size-adjust:none; */
.titleC {
  margin-top: 90px;
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1b1b1b;
  line-height: 22px;
  text-align: center;
}

.titleE {
  margin-top: 20px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #cbcbcb;
  line-height: 22px;
}

.titleLine {
  margin: 40px auto;
  width: 20%;
  height: 1px;
  background: #b2b2b2;
  margin-bottom: 60px;
}

.active {
  color: #216bd1 !important;
}

.allType {
  display: inline-block;
  width: 100%;
  height: auto;
  text-align: center;
  box-sizing: border-box;
  margin-bottom: 0px;
}

.allType ul li {
  display: inline-block;
  line-height: 40px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #676767;
  cursor: pointer;
  position: relative;
}
.clear {
  clear: both;
}

.more {
  /* width: 100%; */
  height: auto;
  text-align: center;
  margin-top: 80px;
  margin-bottom: 150px;
}

/* .more button {
		width: 205px;
		height: 50px;
		background: #FFFFFF;
		border: 1px solid #216BD1;
		border-radius: 5px;
		cursor: pointer;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #216BD1;
		line-height: 19px;
	} */
.bottomj {
  margin-bottom: 200px;
}
@media screen and (max-width: 750px) {
  .more {
    width: 100%;
    height: auto;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue